// Set the hamburger button to toggle the 'monile-nav-is-open' class on and off.
try {
  const toggleNav = document.querySelector('.js-toggleNav');
  toggleNav.addEventListener( 'click', () => {

    if( document.documentElement.classList.contains('mobile-nav-is-open') ){
			document.documentElement.classList.remove('mobile-nav-is-open');
		} else {
			document.documentElement.classList.add('mobile-nav-is-open');
		}

  }, {
		capture: true,
		passive: true
	});

} catch (error) {
  console.log('Error setting up navigation toggle: ', error);
}



// For the links in the navigation with sub menus, set them to toggle the sub menus on click.
try {
  const subMenuToggles = document.querySelectorAll('.menu-item-has-children > .menu-link');
  for( const [i, subMenuToggle] of subMenuToggles.entries() ){
    // console.log(i, subMenuToggle);
    subMenuToggle.addEventListener( 'click', (event) => {

      if( document.documentElement.classList.contains('mobile-nav-is-open') ){
        event.preventDefault();

        const parentLi = event.target.parentElement;
        if( parentLi.classList.contains('menu-item-has-open-sub-menu') ){
          parentLi.classList.remove('menu-item-has-open-sub-menu');
        } else {
          parentLi.classList.add('menu-item-has-open-sub-menu');
        }

        return false;
      }


    }, {
      capture: true
    });
  }

} catch (error) {
  console.log('Error setting up toggles for sub menus in the mobile nav: ', error);
}



// Toggle the search field open and close.
try {
  const toggleNav = document.querySelector('.js-toggleSearch');
  toggleNav.addEventListener( 'click', () => {

    if( document.documentElement.classList.contains('header-search-is-open') ){
			document.documentElement.classList.remove('header-search-is-open');
      document.querySelector('.header-search-field').blue();

		} else {
			document.documentElement.classList.add('header-search-is-open');
      document.querySelector('.header-search-field').focus();
		}

  }, {
		capture: true,
		passive: true
	});

} catch (error) {
  console.log('Error setting up navigation toggle: ', error);
}



// Sticky header
// document.addEventListener('DOMContentLoaded', function() {
//   spendhq_stickyHeader();
// }, false);

// window.addEventListener( 'resize', spendhq_stickyHeader, {passive: true} );
// window.addEventListener( 'scroll', spendhq_stickyHeader, {passive: true} );

// function spendhq_stickyHeader() {
// 	try {
// 			const scroll_position = window.scrollY;
// 			const header = document.querySelector('.header');
// 			const header_height = header.clientHeight;

// 			if( (scroll_position > header_height && window.jp_scrollDirection === 'up') || scroll_position <= header_height ){
// 				header.classList.add('is-sticky');
// 			} else {
// 				header.classList.remove('is-sticky');
// 			}

// 			if( scroll_position <= header_height ){
// 				header.classList.add('is-at-top');
// 			} else {
// 				header.classList.remove('is-at-top');
// 			}

// 	}
// 	catch(error){
// 		console.log(error);
// 	}

// }
